import { ILegalEntityResponseSchema } from '@monetize/types/app';
import { ApiListResponse } from '@monetize/types/common';
import { arrayToObject } from '../utils/misc';

export type ILegalEntitiesSelector = {
  legalEntities: ILegalEntityResponseSchema[];
  defaultLegalEntity?: ILegalEntityResponseSchema;
  legalEntitiesById: Record<string, ILegalEntityResponseSchema>;
};

export const selectLegalEntities = ({
  content,
}: ApiListResponse<ILegalEntityResponseSchema>) => {
  const legalEntities = content.map((legalEntity) =>
    legalEntity.name
      ? legalEntity
      : { ...legalEntity, name: '[Your Company Name]' },
  );

  const legalEntitiesById = arrayToObject(legalEntities, 'id');

  return {
    legalEntities,
    defaultLegalEntity:
      legalEntities.find(({ defaultEntity }) => defaultEntity) ||
      legalEntities[0],
    legalEntitiesById,
  };
};
